
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 33"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.06 19.47a4.501 4.501 0 00-.028-6.339L8.871 1.973C7.889.99 6.689.5 5.273.498c-1.418 0-2.634.506-3.644 1.516C.615 3.03.117 4.236.132 5.639.148 7.042.646 8.233 1.63 9.217l7.373 7.114-7.373 7.373C.616 24.717.119 25.924.134 27.326c.014 1.404.512 2.596 1.495 3.579.984.983 2.176 1.481 3.58 1.496 1.402.016 2.607-.485 3.619-1.497L20.06 19.47z","fill-rule":"evenodd","clip-rule":"evenodd"}})])
          )
        }
      }
    